/* eslint-disable no-irregular-whitespace */
import { bytesToNDigits } from '@mail/cross-sizes-utils';
import { path } from 'ramda';
import React from 'react';
import { BillingDataPlatform } from 'reactApp/api/billing/data/BillingDataAPICall.types';
import { BASEQUOTA } from 'reactApp/appHelpers/configHelpers';
import { MultiSessionDeviceSubs } from 'reactApp/appHelpers/featuresHelpers/features/multiSessionSubscriptions';
import { trialExpiryReminder } from 'reactApp/appHelpers/featuresHelpers/features/trialExpiryReminder';
import { isImapSubscription, isTBankSubscription } from 'reactApp/modules/billingData/billingData.types';
import { cheapestProductIDs } from 'reactApp/modules/products/products.const';
import { isVkMusicSubscription } from 'reactApp/sections/SubscriptionsPage/SubscriptionsPage.helpers';
import {
    type IContent,
    type ISubscriptionModalContent,
    SubscriptionMobileName,
} from 'reactApp/sections/SubscriptionsPage/ui/SubscriptionModal/SubscriptionModal.types';
import { getPeriodName } from 'reactApp/utils/Period';
import { computersGenitive } from 'reactApp/utils/pluralHelpers';

export const useContent = ({ subscription, product, partner }: ISubscriptionModalContent): IContent => {
    let header = <></>;
    const { type, space } = subscription;
    const isTrial = !!path(['isTrial'], subscription);
    const isFreemium = !!path(['isFreemium'], subscription);
    const isPrepaid = !!path(['isPrepaid'], subscription);
    const base = path(['base'], subscription);
    const subsPeriod: any = (isTrial && product?.trialPeriod) || path(['period'], subscription) || product?.period;
    const period = subsPeriod && getPeriodName(subsPeriod, false, true);
    const multiSessionDevicesSubsEnabled = product?.id && MultiSessionDeviceSubs.enabled;

    if (base) {
        header = <>Бесплатный объём Облака {space?.value}</>;
    } else if (isImapSubscription(subscription)) {
        header = <>Создание паролей для приложений</>;
    } else if (isVkMusicSubscription(subscription)) {
        header = (
            <>
                +{space?.value}
                {period && ` на\u00A0${period}`} и VK Музыка
            </>
        );
        /* tempexp_20439-start */
    } else if (multiSessionDevicesSubsEnabled && MultiSessionDeviceSubs.isFreeChoiceProduct(product.id)) {
        const devices = MultiSessionDeviceSubs.getDeviceCount(product.id);
        header = (
            <>
                Вход в Почту с {devices} {computersGenitive(devices)}
            </>
        );
    } else if (multiSessionDevicesSubsEnabled && MultiSessionDeviceSubs.isPresetInSubsProduct(product.id)) {
        const devices = MultiSessionDeviceSubs.getDeviceCount(product.id);
        header = (
            <>
                Mail&nbsp;Space Для&nbsp;работы и&nbsp;вход в&nbsp;Почту с&nbsp;{devices}&nbsp;{computersGenitive(devices)}
            </>
        );
    } else if (isFreemium) {
        /* tempexp_20439-end */
        header = <>Семейный тариф — {space?.value}</>;
    } else if (isTBankSubscription(subscription)) {
        header = <>{space?.value} на месяц</>;
    } else if (product?.isForceDiscountTrial) {
        header = (
            <>
                + {space?.value} {period && `на\u00A0${getPeriodName(product?.period, false, true)}`}
            </>
        );
        // tempexp_16598-next-line
    } else if (product?.id && Object.values(cheapestProductIDs).includes(product.id)) {
        header = <>{bytesToNDigits(BASEQUOTA, 3).value} без рекламы</>;
    } else {
        header = (
            <>
                {isTrial && !isPrepaid && !trialExpiryReminder ? 'Триал' : ''} + {space?.value} {period && `на\u00A0${period}`}
            </>
        );
    }

    let warning = '';

    if (type === BillingDataPlatform.ios || type === BillingDataPlatform.android || type === BillingDataPlatform.rustore) {
        warning = `Данная подписка может быть изменена или отменена в ${SubscriptionMobileName[subscription.type]}`;
    }

    if (partner && Boolean(path(['accountLink'], subscription))) {
        warning = 'Управление тарифом доступно в личном кабинете';
    }

    return { header, warning };
};
